import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const FlowIcon = ({ color }: { color?: string }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorBgContainer;

  return (
    <>
      <g clipPath="url(#clip0_887_64523)">
        <path
          d="M23.5 13C23.5 12.7239 23.2761 12.5 23 12.5C22.0717 12.5 21.1815 12.8687 20.5251 13.5251C19.8687 14.1815 19.5 15.0717 19.5 16C19.5 16.9283 19.8687 17.8185 20.5251 18.4749C21.1815 19.1313 22.0717 19.5 23 19.5C23.2761 19.5 23.5 19.2761 23.5 19V13Z"
          fill={currentColor}
        />
        <path
          d="M30.5 20C30.7761 20 31 19.7761 31 19.5C31 18.5717 30.6313 17.6815 29.9749 17.0251C29.3185 16.3687 28.4283 16 27.5 16C26.5717 16 25.6815 16.3687 25.0251 17.0251C24.3687 17.6815 24 18.5717 24 19.5C24 19.7761 24.2239 20 24.5 20H30.5Z"
          fill={currentColor}
        />
        <path
          d="M16.5 20C16.2239 20 16 20.2239 16 20.5C16 21.4283 16.3687 22.3185 17.0251 22.9749C17.6815 23.6313 18.5717 24 19.5 24C20.4283 24 21.3185 23.6313 21.9749 22.9749C22.6313 22.3185 23 21.4283 23 20.5C23 20.2239 22.7761 20 22.5 20H16.5Z"
          fill={currentColor}
        />
        <path
          d="M23.5 27C23.5 27.2761 23.7239 27.5 24 27.5C24.9283 27.5 25.8185 27.1313 26.4749 26.4749C27.1313 25.8185 27.5 24.9283 27.5 24C27.5 23.0717 27.1313 22.1815 26.4749 21.5251C25.8185 20.8687 24.9283 20.5 24 20.5C23.7239 20.5 23.5 20.7239 23.5 21V27Z"
          fill={currentColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_887_64523">
          <rect width="16" height="16" fill="white" transform="translate(15.5 12)" />
        </clipPath>
      </defs>
    </>
  );
};

export default FlowIcon;
